import { Component } from "@angular/core";

import { Platform, AlertController } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Router } from "@angular/router";
import { ApiService } from "./services/api.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private alertController: AlertController,
    public api: ApiService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.api.showFullLoader = true;

    this.platform.ready().then(() => {
      //console.log("Device UUID is: " + this.device.uuid);
      console.log("platform ready");
      setTimeout(() => {
        this.splashScreen.hide();
      }, 1500);

      this.statusBar.styleLightContent();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString("#07080d");

      this.platform.backButton.subscribe(async () => {
        if (
          (this.router.isActive("/tabs/exchange", true) &&
            this.router.url === "/tabs/exchange") ||
          (this.router.isActive("/tabs/news", true) &&
            this.router.url === "/tabs/news") ||
          (this.router.isActive("/tabs/settings", true) &&
            this.router.url === "/tabs/settings") ||
          (this.router.isActive("/verify", true) &&
            this.router.url === "/verify")
        ) {
          this.router.navigateByUrl("/tabs/home");
        }

        if (
          this.router.isActive("/tabs/home", true) &&
          this.router.url === "/tabs/home"
        ) {
          navigator["app"].exitApp();
        }
      });
    });
  }
}
